import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import moment from "moment";
import { RootState } from "@/store/type";
import { useSelector } from "react-redux";
// import regionsData from "@/app/features/company/data/regions_lite.json";
// import citiesData from "@/app/features/company/data/cities_lite.json";
import { Tabs, Tab, Box } from "@mui/material";
// import ShareIcon from "@mui/icons-material/Share";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { ROLE } from "@/types";
// import { showToast } from "@/app/global-components/toaster";
import { routes } from "@/consts";
// import { cn } from "@/lib/utils";
import useOffer from "@/hooks/useTender";
import TenderEdFormView from "@/pages/vuetender/components/tender-Editform-view";
import TenderStepper from "./header";
import ListofQuatations from "./list-of-Quatations";
// import DeleteOfferSubmitView from "./tender-delete-submit-view";
import QuatationsStatistics from "./statistic.Quatations";
import MarkteComponent from "./MarkteComponent";
import useLobby from "@/hooks/use-lobby";
import { QuotationType } from "@/pages/buyer/home/components/lobby/responsiveSeller/Wedgits/QuotationDetailsModal";
import TenderInfoSeller from "./tender-info-seller";
import DeleteOfferSubmitView from "./tender-delete-submit-view";
// import { FileDownIcon } from "lucide-react";

// interface Product {
//   item: string;
//   quantity: number;
//   unit: string;
//   attachment: { url: string } | null;
//   notice: string;
// }
export interface CompanySchema {
  id: string;
  nameAr: string;
  nameEn: string;
  CompanyNr: string;
  website?: string;
  city?: string;
  region?: string;
}
interface OfferShema {
  title: string;
  value: number;
  deliverDate: string;
  type: string;
  status: string;
  categories: string[];
  categoriesIds: string[];
  region: string;
  city: string;
  products: Array<{
    item: string;
    quantity: number;
    unit: string;
    attachment: { url: string } | null;
    notice: string;
  }>;
  Paylater: string;
  companyId: string;
  fileId: string | null;
  id: string | null;
  userId: string;
}
interface Offer {
  id: string | null;
  isApplied: boolean;
  title: string;
  value: number;
  deliverDate: string;
  type: string;
  status: string;
  categories: string[];
  region: string;
  city: string;
  fileId: string | null;
  TenderNr: string;
  products: Array<{
    item: string;
    quantity: number;
    unit: string;
    attachment: { url: string } | null;
    notice: string;
  }>;
}
// interface City {
//   city_id: number;
//   region_id: number;
//   name_ar: string;
// }
// interface Region {
//   region_id: number;
//   name_ar: string;
// }
// interface Option {
//   value: string;
//   label: string;
// }

const TenderInfoView: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const { id } = useParams();
  const authUser = useSelector((state: RootState) => state.auth.authUser);

  const { getOffer, isLoading, deleteOffer } = useOffer();
  const [offer, setOffer] = useState<Offer | null>(null);
  const [offerED, setOfferEd] = useState<OfferShema | null>(null);
  const navigate = useNavigate();

  // const [regions, setRegions] = useState<Option[]>([]);
  // const [cities, setCities] = useState<Option[]>([]);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [selectedTab, setSelectedTab] = useState(0);
  // useEffect(() => {
  //   setRegions(
  //     regionsData.map((region: Region) => ({
  //       value: region.region_id.toString(),
  //       label: region.name_ar,
  //     }))
  //   );
  // }, []);
  const {
    getListtenderQuotationsByOfferId,
    getListtenderQuotationsByOfferIdMy,
  } = useLobby();
  const [listOffers, setListOffers] = React.useState<QuotationType[]>([]);
  const [totalPages, setTotalPages] = React.useState(1);

  // Early return if no authenticated user
  if (!authUser) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">
            {t("authentication.login")}
          </h2>
          <p className="text-gray-600 mb-4">Please login to view this tender</p>
          <button
            onClick={() => navigate(routes.login)}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
          >
            {t("authentication.login")}
          </button>
        </div>
      </div>
    );
  }

  React.useEffect(() => {
    const fetchQuotations = async () => {
      if (id && authUser?.role) {
        try {
          if (authUser?.role === ROLE.BUYER) {
            const Total = await getListtenderQuotationsByOfferId(id);
            if (Total) {
              setListOffers(Total.data);
              setTotalPages(Math.ceil(Total.data.length / 7));
            } else {
              setListOffers([]);
            }
          } else {
            const Total = await getListtenderQuotationsByOfferIdMy(id);
            if (Total) {
              setListOffers(Total.data);
              setTotalPages(Math.ceil(Total.data.length / 7));
            } else {
              setListOffers([]);
            }
          }
        } catch (error) {
          console.error("Error fetching Offers:", error);
        }
      }
    };
    fetchQuotations();
  }, [id, authUser?.role]);

  const fetchOfferCard = async () => {
    if (id && authUser) {
      try {
        const offerData = await getOffer(id);
        if (offerData) {
          setOffer(offerData.data);
          setOfferEd(offerData.data);
        } else {
          navigate(routes.home);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    if (authUser) {
      fetchOfferCard();
    }
  }, [id, authUser]);

  if (!offer) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          {isLoading ? (
            <div>{t("status.loading")}</div>
          ) : (
            <div>{t("alerts.error.Errorloadingoffer")}</div>
          )}
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (offer && offer.id) {
      try {
        await deleteOffer(offer.id);
        navigate(routes.tenders);
      } catch (err) {
        console.error("Error deleting offer:", err);
      }
    }
  };
  const ShowInfo = () => {
    return (
      <div className="p-3">
        <div className="flex" style={{ justifyContent: "space-between" }}>
          <div className="flex gap-6 items-center">
            <div className="w-6 h-3 bg-purple-600"></div>
            <h3 className="tracking-tight text-3xl font-bold">
              {t("quotations.requestFor")}
            </h3>
          </div>
        </div>
        {authUser && (
          <div className="py-6">
            <TenderStepper status={offer?.status || "Planning"} />
          </div>
        )}
        {authUser?.role === ROLE.BUYER &&
          (offer.status === "Planning" ||
            offer.status === "Opened" ||
            offer.status === "Closed") && (
            <TenderEdFormView
              mutate={fetchOfferCard}
              offer={offerED as any}
              disabled={offer.status === "Opened"}
            />
          )}

        {authUser?.role === ROLE.SELLER && (
          <TenderInfoSeller
            offer={offer}
            listOffers={listOffers}
            totalPages={totalPages}
            id={id}
          />
        )}
        {offer.status !== "Planning" &&
          offer.status !== "Opened" &&
          offer.status !== "Closed" && (
            <div className="flex justify-end">
              <DeleteOfferSubmitView
                isLoading={isLoading}
                onClick={handleDelete}
              />
            </div>
          )}
      </div>
    );
  };

  const renderTabContent = () => {
    switch (selectedTab) {
      case 0:
        return ShowInfo();
      case 1:
        return (
          <ListofQuatations
            listOffers={listOffers}
            totalPages={totalPages}
            offerID={id || ""}
            offerStatus={offer?.status || "Planning"}
            // updateNew={onupdateNew}
          />
        );

      case 2:
        return <QuatationsStatistics offerID={id || ""} />;
      case 3:
        return (
          <MarkteComponent
            offerID={id || ""}
            offerStatus={offer?.status || "Planning"}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-5 w-full md:flex-row space-x-4">
        <section className="w-full" ref={sectionRef}>
          {authUser && authUser.role === ROLE.BUYER ? (
            <>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  mb: 3,
                  backgroundColor: "#fafafa",
                  borderRadius: 2,
                  px: 2,
                  py: 1,
                }}
              >
                <Tabs
                  value={selectedTab}
                  onChange={(e, newValue) => {
                    console.log(e);
                    setSelectedTab(newValue);
                  }}
                  sx={{
                    "& .MuiTabs-flexContainer": {
                      gap: 1,
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#644980",
                      height: 3,
                      borderRadius: "3px 3px 0 0",
                    },
                    "& .MuiTab-root": {
                      minHeight: 48,
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize: "0.875rem",
                      color: "#6b7280",
                      borderRadius: "8px 8px 0 0",
                      marginRight: 1,
                      "&:hover": {
                        backgroundColor: "rgba(59, 130, 246, 0.04)",
                        color: "#644980",
                      },
                      "&.Mui-selected": {
                        color: "#644980",
                        fontWeight: 600,
                        backgroundColor: "rgba(59, 130, 246, 0.08)",
                      },
                      "&.Mui-focusVisible": {
                        backgroundColor: "rgba(59, 130, 246, 0.12)",
                      },
                    },
                  }}
                >
                  <Tab
                    label={t("general.information")}
                    sx={{
                      minWidth: "auto",
                      px: 3,
                    }}
                  />
                  <Tab
                    label={t("statistics.Offers")}
                    sx={{
                      minWidth: "auto",
                      px: 3,
                    }}
                  />
                  <Tab
                    label={t("statistics.title")}
                    sx={{
                      minWidth: "auto",
                      px: 3,
                    }}
                  />
                  <Tab
                    label={t("general.store")}
                    sx={{
                      minWidth: "auto",
                      px: 3,
                    }}
                  />
                </Tabs>
              </Box>
              <Box
                sx={{
                  backgroundColor: "white",
                  borderRadius: 2,
                  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                  overflow: "hidden",
                }}
              >
                {renderTabContent()}
              </Box>
            </>
          ) : (
            <Box
              sx={{
                backgroundColor: "white",
                borderRadius: 2,
                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
              }}
            >
              {renderTabContent()}
            </Box>
          )}
        </section>
      </div>
    </div>
  );
};

export default TenderInfoView;
